import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=09302a06&scoped=true&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Donation.vue?vue&type=style&index=0&id=09302a06&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "09302a06",
  "4b3b6477"
  
)

export default component.exports